import { Transactions } from '../components/transactions/Transactions';
import { AssetClasses } from '../pages/AssetClasses/AssetClasses';
import { AssetClassParameters } from '../pages/AssetClassParameters/AssetClassParameters';
import { AssetClassParametersEdit } from '../pages/AssetClassParameters/AssetClassParametersEdit';
import { AssetClassParametersNew } from '../pages/AssetClassParameters/AssetClassParametersNew';
import { Assets } from '../pages/Assets/Assets';
import { AssetsEdit } from '../pages/Assets/AssetsEdit';
import { AssetsNew } from '../pages/Assets/AssetsNew';
import { AssetStatuses } from '../pages/AssetStatuses/AssetStatuses';
import { AssetTypes } from '../pages/AssetTypes/AssetTypes';
import { AssetTypesEdit } from '../pages/AssetTypes/AssetTypesEdit';
import { AssetTypesNew } from '../pages/AssetTypes/AssetTypesNew';
import { CapacityCategories } from '../pages/CapacityCategories/CapacityCategories';
import { CapacityCategoriesEdit } from '../pages/CapacityCategories/CapacityCategoriesEdit';
import { CapacityCategoriesNew } from '../pages/CapacityCategories/CapacityCategoriesNew';
import { CapacityCategoriesPersons } from '../pages/CapacityCategoriesPersons/CapacityCategoriesPersons';
import { CapacityCategoriesPersonsEdit } from '../pages/CapacityCategoriesPersons/CapacityCategoriesPersonsEdit';
import { CapacityCategoriesPersonsNew } from '../pages/CapacityCategoriesPersons/CapacityCategoriesPersonsNew';
import Customers from '../pages/Customers/Customers';
import CustomersEdit from '../pages/Customers/CustomersEdit';
import CustomersNew from '../pages/Customers/CustomersNew';
import CustomersProjects from '../pages/CustomersProject/CustomersProjects';
import CustomersProjectsEdit from '../pages/CustomersProject/CustomersProjectsEdit';
import CustomersProjectsNew from '../pages/CustomersProject/CustomersProjectsNew';
import DashboardPage from '../pages/DashboardDesktop/DashboardPage';
import { FaultTypes } from '../pages/FaultType/FaultTypes';
import FaultTypesEdit from '../pages/FaultType/FaultTypesEdit';
import FaultTypesNew from '../pages/FaultType/FaultTypesNew';
import { Parameters } from '../pages/Parameters/Parameters';
import { ParametersEdit } from '../pages/Parameters/ParametersEdit';
import { ParametersNew } from '../pages/Parameters/ParametersNew';
import { ProfilePage } from '../pages/Profile/ProfilePage';
import { ResponsiblePersonReport } from '../pages/Reports/AssetResponsiblePerson/ResponsiblePersonReport';
import { AssetReport } from '../pages/Reports/Assets/AssetReport';
import GeneralReport from '../pages/Reports/General/GeneralReport';
import { GroupedWorkSheetReport } from '../pages/Reports/GroupedWorkSheets/GroupedWorkSheetReport';
import { SparePartsReport } from '../pages/Reports/SpareParts/SparePartsReport';
import { TaskReport } from '../pages/Reports/Tasks/TaskReport';
import { TaskServiceDeskReport } from '../pages/Reports/TasksServiceDesk/TaskServiceDeskReport';
import { WorkSheetReport } from '../pages/Reports/WorkSheets/WorkSheetReport';
import Steps from '../pages/Step/Steps';
import StepsEdit from '../pages/Step/StepsEdit';
import StepsNew from '../pages/Step/StepsNew';
import StepGroups from '../pages/StepGroup/StepGroups';
import StepGroupsEdit from '../pages/StepGroup/StepGroupsEdit';
import StepGroupsNew from '../pages/StepGroup/StepGroupsNew';
import TaskAssistancePanelDesktop from '../pages/TaskAssistancePanelDesktop/TaskAssistancePanelDesktop';
import TaskNotificationConfigs from '../pages/TaskNotificationConfig/TaskNotificationConfig';
import TaskNotificationConfigsEdit from '../pages/TaskNotificationConfig/TaskNotificationConfigEdit';
import { TaskNotificationConfigsNew } from '../pages/TaskNotificationConfig/TaskNotificationConfigNew';
import { Tasks } from '../pages/Tasks/Tasks';
import { TasksEditRedirect } from '../pages/Tasks/TasksEditRedirect';
import { TasksMobileView } from '../pages/Tasks/TasksMobileView';
import { TasksNewRedirect } from '../pages/Tasks/TasksNewRedirect';
import { TaskTemplateEdit } from '../pages/TaskTemplates/TaskTemplateEdit';
import TaskTemplates from '../pages/TaskTemplates/TaskTemplates';
import { TerminalMapping } from '../pages/TerminalMapping/TerminalMapping';
import { TerminalMappingEdit } from '../pages/TerminalMapping/TerminalMappingEdit';
import { TerminalMappingNew } from '../pages/TerminalMapping/TerminalMappingNew';
import { TimePeriods } from '../pages/TimePeriods/TimePeriods';
import { TimePeriodsClose } from '../pages/TimePeriods/TimePeriodsClose';
import { TimePeriodsOpen } from '../pages/TimePeriods/TimePeriodsOpen';
import { Units } from '../pages/Units/Units';
import { UnitsEdit } from '../pages/Units/UnitsEdit';
import { UnitsNew } from '../pages/Units/UnitsNew';
import UserColors from '../pages/UserColors/UserColors';
import UserColorsEdit from '../pages/UserColors/UserColorsEdit';
import UsersColorNew from '../pages/UserColors/UsersColorNew';
import WorkActivity from '../pages/WorkActivities/WorkActivity';
import { WorkActivityGroupDetail } from '../pages/WorkActivityGroups/WorkActivityGroupDetail';
import WorkActivityGroups from '../pages/WorkActivityGroups/WorkActivityGroups';
import { WorkSheets } from '../pages/WorkSheets/WorkSheets';
import { WorkSheetsEdit } from '../pages/WorkSheets/WorkSheetsEdit';
import { WorkSheetsNew } from '../pages/WorkSheets/WorkSheetsNew';
import { WorksheetsEdit } from '../pages/WorksheetsDev/WorksheetsEdit';
import { WorksheetsNew } from '../pages/WorksheetsDev/WorksheetsNew';
import { UserRoles } from '../types/applicationUser.types';

export const routes = [
  {
    path: '/home',
    component: DashboardPage,
  },
  {
    path: '/profile',
    component: ProfilePage,
  },
  {
    path: '/assets',
    component: Assets,
    restrictedAccess: [UserRoles.AssetRead, UserRoles.AssetEdit],
  },
  {
    path: '/assets/new',
    component: AssetsNew,
    restrictedAccess: [UserRoles.AssetEdit],
  },
  {
    path: '/assets/new/:id',
    component: AssetsNew,
    restrictedAccess: [UserRoles.AssetEdit],
  },
  {
    path: '/assets/edit/:id',
    component: AssetsEdit,
    restrictedAccess: [UserRoles.AssetRead, UserRoles.AssetEdit],
  },
  {
    path: '/asset-classes',
    component: AssetClasses,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/asset-class-parameters',
    component: AssetClassParameters,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/asset-class-parameters/new',
    component: AssetClassParametersNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/asset-class-parameters/edit/:id',
    component: AssetClassParametersEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/asset-types',
    component: AssetTypes,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/asset-types/edit/:id',
    component: AssetTypesEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/asset-types/new/',
    component: AssetTypesNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/asset-statuses',
    component: AssetStatuses,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/capacity-categories',
    component: CapacityCategories,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/capacity-categories/new',
    component: CapacityCategoriesNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/capacity-categories/edit/:id',
    component: CapacityCategoriesEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/capacity-categories-persons',
    component: CapacityCategoriesPersons,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/capacity-categories-persons/new',
    component: CapacityCategoriesPersonsNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/capacity-categories-persons/edit/:id',
    component: CapacityCategoriesPersonsEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/parameters',
    component: Parameters,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/parameters/new',
    component: ParametersNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/parameters/edit/:id',
    component: ParametersEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/admin-terminal-mapping',
    component: TerminalMapping,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/admin-terminal-mapping/new',
    component: TerminalMappingNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/admin-terminal-mapping/edit/:id',
    component: TerminalMappingEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/units',
    component: Units,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/units/new',
    component: UnitsNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/units/edit/:id',
    component: UnitsEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/customers',
    component: Customers,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/customers/new',
    component: CustomersNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/customers/edit/:id',
    component: CustomersEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/user-colors',
    component: UserColors,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/user-colors/new',
    component: UsersColorNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/user-colors/edit/:id',
    component: UserColorsEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/customers-projects',
    component: CustomersProjects,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/customers-projects/new',
    component: CustomersProjectsNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/customers-projects/edit/:id',
    component: CustomersProjectsEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/fault-types',
    component: FaultTypes,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/fault-types/new',
    component: FaultTypesNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/fault-types/edit/:id',
    component: FaultTypesEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/tasks',
    component: Tasks,
    restrictedAccess: [UserRoles.TaskRead],
  },
  {
    path: '/tasks-mobile-view',
    component: TasksMobileView,
    restrictedAccess: [UserRoles.TaskRead],
  },
  {
    path: '/tasks/new',
    component: TasksNewRedirect,
    restrictedAccess: [],
  },
  {
    path: '/tasks/new/:id',
    component: TasksNewRedirect,
    restrictedAccess: [],
  },
  {
    path: '/tasks/edit/:id',
    component: TasksEditRedirect,
  },
  {
    path: '/tasks/notification-config',
    component: TaskNotificationConfigs,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/tasks/notification-config/new',
    component: TaskNotificationConfigsNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/tasks/notification-config/edit/:id',
    component: TaskNotificationConfigsEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/task-templates',
    component: TaskTemplates,
  },
  {
    path: '/task-templates/edit/:id',
    component: TaskTemplateEdit,
  },
  {
    path: '/workSheets/new/:assetId/:taskId',
    //component: WorkSheetsNew,
    component: WorksheetsNew,
    restrictedAccess: [UserRoles.WorksheetAll, UserRoles.WorksheetOwn],
  },
  {
    path: '/workSheets',
    component: WorkSheets,
    restrictedAccess: [UserRoles.WorksheetAll, UserRoles.WorksheetOwn],
  },
  {
    path: '/workSheets/edit/:id',
    //component: WorkSheetsEdit,
    component: WorksheetsEdit,
  },
  {
    path: '/work-activity-groups',
    component: WorkActivityGroups,
  },
  {
    path: '/work-activity-groups/detail/:id',
    component: WorkActivityGroupDetail,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/work-activity-groups/detail',
    component: WorkActivityGroupDetail,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/work-activities',
    component: WorkActivity,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/steps',
    component: Steps,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/steps/edit/:id',
    component: StepsEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/steps/new',
    component: StepsNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/step-groups',
    component: StepGroups,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/step-groups/edit/:id',
    component: StepGroupsEdit,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/step-groups/new',
    component: StepGroupsNew,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/task-assistance-panels',
    component: TaskAssistancePanelDesktop,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/reports/1/:settingId?',
    component: ResponsiblePersonReport,
  },
  {
    path: '/reports/2/:settingId?',
    component: TaskReport,
  },
  {
    path: '/reports/3/:settingId?',
    component: WorkSheetReport,
    restrictedAccess: [UserRoles.WorksheetAll, UserRoles.WorksheetOwn],
  },
  {
    path: '/reports/5/:settingId?',
    component: AssetReport,
  },
  {
    path: '/reports/6/:settingId?',
    component: SparePartsReport,
  },
  {
    path: '/reports/7/:settingId?',
    component: GroupedWorkSheetReport,
  },
  {
    path: '/reports/8/:settingId?',
    component: TaskServiceDeskReport,
  },
  {
    path: '/generalReports/:id/:generalReportSettingId?',
    component: GeneralReport,
  },
  {
    path: '/transactions',
    component: Transactions,
  },
  {
    path: '/timeperiods',
    component: TimePeriods,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/timeperiods/close/:id',
    component: TimePeriodsClose,
    restrictedAccess: [UserRoles.Admin],
  },
  {
    path: '/timeperiods/open/:id',
    component: TimePeriodsOpen,
    restrictedAccess: [UserRoles.Admin],
  },
];

export default routes;
/*
const AssetTypesNew = React.lazy(() => import('../pages/AssetTypes/AssetTypesNew'));
const AssetTypesEdit =  React.lazy(() => import('../pages/AssetTypes/AssetTypesEdit'));
const AssetStatuses = React.lazy(() => import('../pages/AssetStatuses/AssetStatuses'));
const CapacityCategories = React.lazy(() => import('../pages/CapacityCategories/CapacityCategories'));
const CapacityCategoriesNew = React.lazy(() => import('../pages/CapacityCategories/CapacityCategoriesNew'));
const CapacityCategoriesEdit = React.lazy(() => import('../pages/CapacityCategories/CapacityCategoriesEdit'));
const CapacityCategoriesPersons = React.lazy(() => import('../pages/CapacityCategoriesPersons/CapacityCategoriesPersons'));
const CapacityCategoriesPersonsNew = React.lazy(() => import('../pages/CapacityCategoriesPersons/CapacityCategoriesPersonsNew'));
const Parameters =   React.lazy(() => import('../pages/Parameters/Parameters'));
const ParametersNew = React.lazy(() => import('../pages/Parameters/ParametersNew'));
const ParametersEdit =  React.lazy(() => import('../pages/Parameters/ParametersEdit'));
const Units =  React.lazy(() => import( '../pages/Units/Units'));
const UnitsNew =  React.lazy(() => import('../pages/Units/UnitsNew'));
const UnitsEdit =  React.lazy(() => import('../pages/Units/UnitsEdit'));
const AssetsNew =  React.lazy(() => import('../pages/Assets/AssetsNew'));
const CapacityCategoriesPersonsEdit =  React.lazy(() => import('../pages/CapacityCategoriesPersons/CapacityCategoriesPersonsEdit'));
const ResponsiblePersonReport =  React.lazy(() => import('../pages/Reports/ResponsiblePersonReport'));
const Transactions = React.lazy(() => import('../components/transactions/Transactions'));
const AssetClassParameters =  React.lazy(() => import('../pages/AssetClassParameters/AssetClassParameters'));
const AssetClassParametersNew = React.lazy(() => import('../pages/AssetClassParameters/AssetClassParametersNew'));
const AssetClassParametersEdit=  React.lazy(() => import('../pages/AssetClassParameters/AssetClassParametersEdit'));
const Tasks =  React.lazy(() => import('../pages/Tasks/Tasks'));
const TasksNew =  React.lazy(() => import('../pages/Tasks/TasksNew'));
const TasksEdit =  React.lazy(() => import('../pages/Tasks/TasksEdit'));
 */
